import { createSelector } from 'reselect'
import { getLocalizedText as getLocalizedTextImport } from './localized/selectors'
import {
    getVersions as getVersionsImport,
    getClient as getClientImport,
} from './versions/selectors'
import { getSteam as getSteamImport } from './steam/selectors'
import { getServerName as getServerNameImport, getServerShortName } from './serverNames/selectors'
import {
    getProgresses as getProgressesImport,
    getProgressForServer as getProgressForServerImport,
} from './progress/selectors'

const getServer = state => getServerShortName(state.serverNames)
const getProgresses = state => getProgressesImport(state.progress)
const getProgress = createSelector(
    [getServer, getProgresses],
    (server, progresses) => (progresses[server] ? progresses[server] : { percent: 0, message: '' }),
)

const getServerName = state => getServerNameImport(state.serverNames)
const getClient = state => getClientImport(state.versions)
const getLocalizedText = state => getLocalizedTextImport(state.localized)
const getClientText = createSelector(
    [getServerName, getClient, getLocalizedText],
    (server, clientVersion, localizedText) => {
        if (server !== '' && clientVersion !== -1) {
            return localizedText.versionText
                .replace('{server}', server)
                .replace('{version}', clientVersion)
        }
        return ''
    },
)

const getPatchNotes = createSelector(
    [getServerName, getClient, getLocalizedText],
    (server, clientVersion, localizedText) => {
        if (server !== '' && clientVersion !== -1) {
            return localizedText.patchNotes
        }
        return null
    },
)

// eslint-disable-next-line
export const selectors = {
    // localized
    getLocalizedText,

    // versions
    getVersions: state => getVersionsImport(state.versions),

    // steam
    getSteam: state => getSteamImport(state.steam),

    // server names
    getServerName,

    // progress
    getProgress, // : state => getProgress(state),

    getProgressForServer: (state, server) => getProgressForServerImport(state.progress, server),

    // get client text
    getClientText, // : state => getClientText(state),

    // get patch notes
    getPatchNotes, // : state => getPatchNotes(state),
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/selectors.js